/* eslint-ignore */
// @ts-nocheck
import React, { createContext, useContext, useState } from 'react';

const FirstAccessContext = createContext();

export function FirstAccessProvider({ children }) {
  const [codCond, setCodCond] = useState('');
  const [document, setDocument] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [checkPrivacyPolicy, setCheckPrivacyPolicy] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [siteId, setSiteId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [address, setAddress] = useState([]);
  const [corporateName, setCorporateName] = useState('');
  const [contactId, setContactId] = useState('');

  const handleSetAddress = (addressParam) => {
    setAddress(addressParam);
  };

  const handleSetCodCond = (codCondParam) => {
    setAddress([]);
    setSiteId(null);
    setCorporateName('');
    setCodCond(codCondParam);
  };

  const handleSetDocument = (documentParam) => {
    setAddress([]);
    setSiteId(null);
    setCorporateName('');
    setDocument(documentParam);
  };

  const handleSetCheckPrivacyPolicy = (privacyPolicyParam) => {
    setCheckPrivacyPolicy(privacyPolicyParam);
  };

  const handleSetName = (nameParam) => {
    setName(nameParam);
  };

  const handleSetLastName = (lastNameParam) => {
    setLastName(lastNameParam);
  };

  const handleSetEmail = (emailParam) => {
    setEmail(emailParam);
  };

  const handleSetPhone = (phoneParam) => {
    if (phoneParam.length > 15) return;
    setPhone(phoneParam);
  };

  const handleSetPassword = (passwordParam) => {
    setPassword(passwordParam);
  };

  const handleSetPasswordAgain = (passwordAgainParam) => {
    setPasswordAgain(passwordAgainParam);
  };

  const handleSetSiteId = (siteIdParam) => {
    setSiteId(siteIdParam);
  };

  const handleSetUserId = (userIdParam) => {
    setUserId(userIdParam);
  };

  const handleSetCorporateName = (corporateNameParam) => {
    setCorporateName(corporateNameParam);
  };

  const handleSetContactId = (contactIdParam) => {
    setContactId(contactIdParam);
  };

  return (
    <FirstAccessContext.Provider
      value={{
        codCond,
        handleSetCodCond,
        document,
        handleSetDocument,
        checkPrivacyPolicy,
        handleSetCheckPrivacyPolicy,
        name,
        handleSetName,
        lastName,
        handleSetLastName,
        email,
        handleSetEmail,
        phone,
        handleSetPhone,
        password,
        handleSetPassword,
        passwordAgain,
        handleSetPasswordAgain,
        siteId,
        handleSetSiteId,
        userId,
        handleSetUserId,
        address,
        handleSetAddress,
        corporateName,
        handleSetCorporateName,
        contactId,
        handleSetContactId,
      }}
    >
      {children}
    </FirstAccessContext.Provider>
  );
}

export function useFirstAccess() {
  const context = useContext(FirstAccessContext);

  return context;
}
